export default __webpack_public_path__ + "static/media/login-gradient.35f95fa7.png";